<template>
  <div class="device-list">
    <PageHeader>
      <div style="display: flex;justify-content: space-between">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('Device.installed')" name="installed"></el-tab-pane>
          <el-tab-pane :label="$t('Device.uninstall')" name="uninstall"></el-tab-pane>
        </el-tabs>
        <Select
          :query="`${this.$api.product.product_select}?type=steamingOven`"
          v-model="productId"
          :placeholder="$t('Device.productModel')"
          @change="handleProductChange"
        >
        </Select>
      </div>
    </PageHeader>

    <!--      <Select-->
    <!--        :query="`${this.$api.product.product_select}`"-->
    <!--        v-model="productId"-->
    <!--        :placeholder="$t('Device.product')"-->
    <!--        @change="handleProductChange"-->
    <!--      >-->
    <!--      </Select>-->
    <div style="width: 100%">
      <DeviceStatistic :productId="productId" v-if="refreshed" />
    </div>

    <CardContainer>
      <div class="btn-group">
        <hl-button @click="add" v-if="addRole" class="btn">
          {{ $t('Common.create') }}
        </hl-button>
        <UploadButton
          v-if="addRole"
          :accept="'.xls, .xlsx'"
          :http-request="importDevice"
          class="btn"
        >
          <hl-button type="secondary" action="" :loading="importLoading">
            {{ $t('Common.importData') }}
          </hl-button>
        </UploadButton>
        <hl-button
          v-if="addRole"
          type="secondary"
          class="btn"
          :loading="exportLoading"
          @click="exportDevice"
        >
          {{ $t('Common.exportData') }}
        </hl-button>
        <hl-button
          v-if="addRole"
          type="text"
          class="btn"
          :loading="downloadLoading"
          @click="exportTemp"
        >
          {{ $t('Device.excel') }}
          <i class="el-icon  el-icon-bottom" style="font-size: 14px;"></i>
        </hl-button>
      </div>
      <CommonForm ref="search" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>

    <DeviceEdit v-if="visible" :visible.sync="visible" :row="row" @refresh="refresh" />
    <DeviceCommand v-if="cmdVisible" :visible.sync="cmdVisible" :row="row" @refresh="formSearch" />
    <DeviceImportFail
      v-if="importFailVisible"
      :visible.sync="importFailVisible"
      :tableData="importFailData"
      :successData="importSuccessData"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import tablejson from './Model/Tablejson.Index'
import formjson from './Model/Formjson.Index'

import formTableMixin from '@/mixins/formTableMixin'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'
import { downloadFile } from '@/utils/download'

import DeviceStatistic from './DeviceStatistic'
import DeviceEdit from './DeviceEdit'
import DeviceCommand from './DeviceCommand'
import UploadButton from '@/components/Upload/UploadButton'
import DeviceImportFail from './DeviceImportFail'
import Select from '@/components/CommonForm/Select'

export default {
  mixins: [formTableMixin, getRoleFromPath],
  components: {
    Select,
    DeviceStatistic,
    DeviceEdit,
    DeviceCommand,
    UploadButton,
    DeviceImportFail
    // Select,
  },
  data() {
    return {
      tablejson,
      formjson,
      refreshed: true, //列表新建,编辑,删除后刷新
      activeName: 'installed',
      operation: [
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail',
          hide: () => {
            return !this.detailRole
          }
        },
        {
          name: this.$t('Common.edit'),
          icon: 'icon-edit_16',
          type: 'edit',
          hide: () => {
            return !this.updateRole
          }
        },
        {
          name: this.$t('Common.delete'),
          icon: 'icon-del_16',
          type: 'delete',
          hide: () => {
            return !this.deleteRole
          }
        },
        {
          name: this.$t('Device.unbinding'),
          type: 'unbind',
          hide: (row) => {
            return !this.unbindRole || !row.bind
          }
        }
        // {
        //   name: this.$t('Device.cmdPush'),
        //   type: 'cmd',
        //   width: 100,
        //   hide: () => {
        //     return !this.cmdRole
        //   }
        // },
        // {
        //   name: this.$t('Device.childDevice'),
        //   type: 'child',
        //   hide: (row) => {
        //     return row.category != 'gateway'
        //   }
        // }
      ],
      visible: false,
      row: {},
      queryApi: this.$api.device.device_list,
      cmdVisible: false,
      importLoading: false,
      exportLoading: false,
      downloadLoading: false,
      importFailVisible: false,
      importFailData: [],
      importSuccessData: [],
      productId: '',
      userId: this.$route.params.coid ? this.$route.params.coid : ''
    }
  },
  computed: {
    roleChildList() {
      let deviceRole = getRoleByOperationCode(this.role.childList, 'device_list')
      console.log(deviceRole)
      return deviceRole && deviceRole.isPermission === 'Y' ? deviceRole.childList : []
    },
    // 新建
    addRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'detail')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    //解绑
    unbindRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'unbind')
      return val ? val.isPermission == 'Y' : false
    },
    // 指令下发
    cmdRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'cmd')
      return val ? val.isPermission == 'Y' : false
    }
  },
  // watch:{
  //   productId() {
  //     this.getStatisticsData()
  //   }
  // },
  mounted() {
    if (this.$route.params.coid) {
      this.$refs.search.setOption('userId', this.$route.params.coid)
    }
  },
  methods: {
    handleProductChange(value) {
      this.$nextTick(() => {
        this.formSearch()
      })
    },
    handleClick(val) {
      if (this.activeName === 'uninstall') {
        const { href } = this.$router.resolve({
          name: 'DeviceUninstall'
        })
        window.open(href, '_self')
      }
    },
    // formSearch(data) {
    //   this.search(data, null, this.queryApi)
    // },
    refresh() {
      this.refreshed = false
      this.formSearch()
    },
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      data = {
        ...data,
        productKey: this.productId
      }
      this.search(data, pageObj, this.queryApi)
      // this.$router.replace('/purchase/materialSupplier')
      this.$nextTick(() => {
        this.refreshed = true
      })
    },
    add() {
      this.row = {}
      this.visible = true
    },
    importDevice(params) {
      this.importLoading = true

      const formData = new FormData()
      formData.append('file', params.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax
        .post(this.$api.device.device_import, formData, config)
        .then((res) => {
          if (res.data.failData.length > 0) {
            this.importFailVisible = true
            this.importSuccessData = res.data.successData
            this.importFailData = res.data.failData
          } else {
            this.formSearch()
            this.$message.success(`${this.$t('Common.operationSuccess')}`)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.importLoading = false
        })
    },
    exportDevice() {
      this.exportLoading = true
      this.$ajax
        .download(this.$api.device.device_export, this.cacheData)
        .then((res) => {
          downloadFile(res)
        })
        .catch(() => {})
        .finally(() => {
          this.exportLoading = false
        })
    },
    exportTemp() {
      this.downloadLoading = true
      this.$ajax
        .download(this.$api.device.device_import_template_download, this.cacheData)
        .then((res) => {
          downloadFile(res)
        })
        .catch(() => {})
        .finally(() => {
          this.downloadLoading = false
        })
    },

    handleDelete(row) {
      this.$confirm(`${this.$t('Common.operationTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.device.device_delete, params)
            .then(() => {
              this.refreshed = false
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              const pageObj = {
                ...this.cachePage
              }
              // 当前页最后一条数据并且不是第一页时，删除完之后需要查询前一页的数据
              if (this.tableData.length === 1 && this.cachePage.pageNum > 1) {
                pageObj.pageNum = this.cachePage.pageNum - 1
              }
              this.formSearch(this.cacheData, pageObj)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleUnbind(row) {
      this.$confirm(`${this.$t('Device.unbindTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.device.device_unbind, params)
            .then((res) => {
              if (res.success) {
                this.$message.success(`${this.$t('Common.operationSuccess')}`)
              }

              this.refreshed = false
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDetail(row) {
      const { href } = this.$router.resolve({
        name: 'DeviceDetail',
        query: {
          id: row.id
        }
      })
      window.open(href, '_blank')
    },
    handleCmd(row) {
      if (row.online !== 'online') {
        return this.$message.warning(`${this.$t('Device.tips1')}`)
      }
      this.row = row
      this.cmdVisible = true
    },
    handleChild(row) {
      console.log('row', row)
      const { href } = this.$router.resolve({
        name: 'Device',
        query: {
          gatewayId: row.id
        }
      })
      window.open(href, '_blank')
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'unbind':
          this.handleUnbind(row)
          break
        case 'cmd':
          this.handleCmd(row)
          break
        case 'child':
          this.handleChild(row)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-group {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.btn {
  margin-right: 10px;
}
</style>
